// extracted by mini-css-extract-plugin
export default {"headerLink":"automated-inbox-searchs_headerLink__H8eul","link":"automated-inbox-searchs_link__jmRS8"};